webpackJsonp([35],{

/***/ 421:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchbox-container":"_3YnTLNfmd3w2t8LfeCl5fX","searchbox-form":"_231Wqkqv3Ra7O2V-21kAEZ","searchbox-form-filterstyle":"_rV2rdyGi1l5Gi0n3HsvU _231Wqkqv3Ra7O2V-21kAEZ","searchbox-input":"_3pyOYW52maN2pcbPD7hX6d","searchbox-input-filterstyle":"_3KXMz6RIMQey6Pe1U5EEGF","searchbox-button":"KOnHv7wA0UhmSM7NKvYCG","searchbox-button-hide-mobile":"_1-WxwTzzWZgarg3SylNXGp KOnHv7wA0UhmSM7NKvYCG _13UyNN6lRQaIE4nGDzE2-d","searchbox-clear-mobile":"_2oqPz2BB-g47sgQq3tCxSI _3jblqlydyeJqpKzpSv89pq","action-container":"_1-EeLQRhosIC9GpJsvabWZ","action-container-filterstyle":"_3EPhllxrf2sKLUR0O6SeM2","results":"_1CB4-w-1rpskxtllTNAmy5","result":"_1yFxWUwY2bGAOa7CVae5Fg","result-bold":"vUvZ1O7M4VsssEocpPHTl","result-active":"HxVeMi8_2Ae4Vi7OHWHTk _1yFxWUwY2bGAOa7CVae5Fg"};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SearchBox = __webpack_require__(421);
	
	var _SearchBox2 = _interopRequireDefault(_SearchBox);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _search = __webpack_require__(80);
	
	var _suggestion = __webpack_require__(220);
	
	var _session = __webpack_require__(22);
	
	var _search2 = __webpack_require__(198);
	
	var _suggestion2 = __webpack_require__(482);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  SearchBox: {
	    displayName: 'SearchBox'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/SearchBox.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import { parseFilterToQuery, matchTextToFilter } from 'utils/search';
	// import levenshtein from 'levenshtein-edit-distance';
	
	
	var SearchBox = _wrapComponent('SearchBox')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    path: state.routing.locationBeforeTransitions.pathname,
	    trip: state.trip.data,
	    filter: state.search.filter,
	    mobileFilter: state.search.mobileFilter,
	    results: state.suggestion.results,
	    resultIndex: state.suggestion.resultIndex,
	    text: state.suggestion.text,
	    originalText: state.suggestion.originalText,
	    keywords: state.suggestion.keywords,
	    destinations: state.search.options.destinations,
	    activities: state.search.options.activities,
	    messages: state.language.messages
	    // userConfig: state.info.userConfig,
	  };
	}, (0, _extends3.default)({}, _reactRouterRedux.routerActions, { search: _search.search, openMobileFilter: _search.openMobileFilter, searchSuggestion: _search.searchSuggestion, prepFilter: _search.prepFilter, openMobileNav: _session.openMobileNav, goUp: _suggestion.goUp, goDown: _suggestion.goDown, goTo: _suggestion.goTo, clearResults: _suggestion.clearResults, setText: _suggestion.setText, getResults: _suggestion.getResults, goToAndSet: _suggestion.goToAndSet })), _dec2 = (0, _reactCssModules2.default)(_SearchBox2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(SearchBox, _Component);
	
	  function SearchBox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchBox.__proto__ || (0, _getPrototypeOf2.default)(SearchBox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	      var value = e.target.value;
	      // if (!value) {
	      //   this.clearInput();
	      // } else {
	      // this.props.setText(e.target.value);
	      _this.props.setText(e.target.value);
	      _this.props.getResults(value);
	      // setTimeout(() => this.getResults(value), 300);
	      // }
	    }, _this.getResults = function (value) {
	      if (value === _this.props.text) {
	        _this.props.getResults(value);
	      }
	    }, _this.getChoice = function () {
	      // if (this.props.userConfig.suggestionEnabled && !this.props.text) {
	      if (!_this.props.text) {
	        _this.props.getResults('');
	      }
	    }, _this.clearInput = function () {
	      // if (this.props.userConfig.suggestionEnabled) {
	      //   this.props.getResults('');
	      // } else {
	      //   this.props.clearResults();
	      //   this.props.setText();
	      // }
	      // this.props.getResults('');
	      _this.props.clearResults();
	      _this.props.setText();
	      // setTimeout(()=> {
	      //   this.refs.searchInput.value = '';
	      //   console.log('text', this.props.text);
	      // }, 2000);
	    }, _this.handleKeyDown = function (e) {
	      if (e.keyCode === 38) {
	        _this.props.goUp();
	        e.preventDefault();
	      }
	      if (e.keyCode === 40 || e.keyCode === 9) {
	        _this.props.goDown();
	        e.preventDefault();
	      }
	      if (e.keyCode === 13 && _this.props.resultIndex !== -1) {
	        // this.props.goToAndSet(this.props.resultIndex);
	        e.preventDefault();
	        _this.handleMouseClick(_this.props.resultIndex);
	      }
	    }, _this.handleMouseOver = function (index) {
	      _this.props.goTo(index);
	    }, _this.handleMouseClick = function (index) {
	      var _this$props = _this.props,
	          filter = _this$props.filter,
	          path = _this$props.path,
	          mobileFilter = _this$props.mobileFilter,
	          results = _this$props.results,
	          originalText = _this$props.originalText;
	      // const sessionId = Math.random().toString(36).substring(7);
	
	      _this.props.goToAndSet(index); // Set first
	      if (path.startsWith('/search')) {
	        var newFilter = _lodash2.default.cloneDeep((0, _extends3.default)({}, _search2.defaultFilter, { session_id: filter.session_id, quantity: filter.quantity, text: results[index], raw_keyword: _this.props.originalText, click_suggest: true }));
	        // const newFilter = _.cloneDeep({...filter, text: results[index], raw_keyword: this.props.originalText, click_suggest: true});
	        (0, _search2.matchTextToFilter)(newFilter, _this.props.destinations, _this.props.activities, _this.props.keywords);
	        _this.props.prepFilter(newFilter, true);
	        // if (!mobileFilter) {
	        //   if (newFilter.text) {
	        //     this.props.searchSuggestion(newFilter.text);
	        //   }
	        //   this.props.search(newFilter);
	        // }
	        _this.props.setText(newFilter.text);
	        if (newFilter.text) {
	          _this.props.searchSuggestion(newFilter.text);
	        }
	        if (mobileFilter) {
	          _this.props.openMobileFilter(false);
	        }
	        _this.props.search(newFilter);
	      } else {
	        // this.props.push(`/search?text=${escape(this.props.results[index])}&raw_keyword=${this.props.originalText}&session_id=${sessionId}&click_suggest=true`);
	        _this.props.push('/search/Any?text=' + encodeURIComponent(results[index]) + '&raw_keyword=' + encodeURIComponent(originalText) + '&click_suggest=true');
	      }
	      // this.props.clearResults();
	      _this.refs.searchInput.blur();
	    }, _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var _this$props2 = _this.props,
	          resultIndex = _this$props2.resultIndex,
	          filter = _this$props2.filter,
	          path = _this$props2.path,
	          mobileFilter = _this$props2.mobileFilter,
	          text = _this$props2.text,
	          originalText = _this$props2.originalText;
	      // const {resultIndex, filter, mobileFilter, text} = this.props;
	      // const sessionId = Math.random().toString(36).substring(7);
	
	      if (resultIndex === -1) {
	        if (path.startsWith('/search')) {
	          var newFilter = _lodash2.default.cloneDeep((0, _extends3.default)({}, _search2.defaultFilter, { session_id: filter.session_id, quantity: filter.quantity, text: text, raw_keyword: text, click_suggest: false }));
	          // const newFilter = _.cloneDeep({...filter, text: text, raw_keyword: text, click_suggest: false});
	          (0, _search2.matchTextToFilter)(newFilter, _this.props.destinations, _this.props.activities, _this.props.keywords);
	          _this.props.prepFilter(newFilter, true);
	          // if (!mobileFilter) {
	          //   if (newFilter.text) {
	          //     this.props.searchSuggestion(newFilter.text);
	          //   }
	          //   this.props.search(newFilter);
	          // }
	          _this.props.setText(newFilter.text);
	          if (newFilter.text) {
	            _this.props.searchSuggestion(newFilter.text);
	          }
	          if (mobileFilter) {
	            _this.props.openMobileFilter(false);
	          }
	          _this.props.search(newFilter);
	        } else {
	          var str = text.replace(/\s+$/, '');
	          if (str) {
	            _this.props.push('/search/Any?text=' + encodeURIComponent(str) + '&raw_keyword=' + encodeURIComponent(originalText) + '&sort=' + encodeURIComponent('Most relevant'));
	            _this.props.setText();
	          } else {
	            // this.props.push(`/search?sort=Recommended&session_id=${sessionId}`);
	            // this.props.push(`/search/Any?sort=Recommended`);
	            _this.props.push('/search/Any');
	          }
	        }
	      }
	      _this.refs.searchInput.blur();
	      // this.props.clearResults();
	    }, _this.clearResults = function () {
	      _this.props.clearResults();
	    }, _this.ignoreFocus = function (e) {
	      e.preventDefault();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchBox, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          originalText = _props.originalText,
	          text = _props.text,
	          resultIndex = _props.resultIndex,
	          results = _props.results,
	          filterStyle = _props.filterStyle,
	          messages = _props.messages;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'searchbox-container' },
	        _react3.default.createElement(
	          'form',
	          { styleName: filterStyle ? 'searchbox-form-filterstyle' : 'searchbox-form', onSubmit: this.handleSubmit, onBlur: this.clearResults },
	          _react3.default.createElement('input', { ref: 'searchInput', type: 'search', value: text, onChange: this.onChange, onKeyDown: this.handleKeyDown, styleName: filterStyle ? 'searchbox-input-filterstyle' : 'searchbox-input', placeholder: messages['search.search_filter.search.placeholder'], onFocus: this.getChoice }),
	          _react3.default.createElement(
	            'div',
	            { styleName: filterStyle ? 'action-container-filterstyle' : 'action-container' },
	            _react3.default.createElement('button', { type: 'submit', styleName: text ? 'searchbox-button-hide-mobile' : 'searchbox-button', onMouseDown: this.ignoreFocus }),
	            _react3.default.createElement('button', { type: 'reset', styleName: 'searchbox-clear-mobile', style: text ? null : { display: 'none' }, onMouseDown: this.ignoreFocus, onClick: this.clearInput })
	          ),
	          results.length > 0 && _react3.default.createElement(
	            'div',
	            { styleName: 'results' },
	            results.map(function (res, index) {
	              var hilightIndexes = (0, _suggestion2.hilightKeyword)(res, originalText);
	              return _react3.default.createElement(
	                'p',
	                { key: index, styleName: index === resultIndex ? 'result-active' : 'result', onMouseOver: _this2.handleMouseOver.bind(_this2, index), onMouseDown: _this2.ignoreFocus, onClick: _this2.handleMouseClick.bind(_this2, index) },
	                res.split('').map(function (r, i) {
	                  if (hilightIndexes.indexOf(i) >= 0) {
	                    return _react3.default.createElement(
	                      'span',
	                      { styleName: 'result-bold', key: i },
	                      r
	                    );
	                  }
	                  return _react3.default.createElement(
	                    'span',
	                    { key: i },
	                    r
	                  );
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return SearchBox;
	}(_react2.Component), _class2.propTypes = {
	  onChange: _react2.PropTypes.func,
	  push: _react2.PropTypes.func,
	  path: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  filter: _react2.PropTypes.object,
	  mobileFilter: _react2.PropTypes.bool,
	  search: _react2.PropTypes.func,
	  searchSuggestion: _react2.PropTypes.func,
	  prepFilter: _react2.PropTypes.func,
	  openMobileNav: _react2.PropTypes.func,
	  goUp: _react2.PropTypes.func,
	  goDown: _react2.PropTypes.func,
	  goTo: _react2.PropTypes.func,
	  goToAndSet: _react2.PropTypes.func,
	  getResults: _react2.PropTypes.func,
	  clearResults: _react2.PropTypes.func,
	  setText: _react2.PropTypes.func,
	  results: _react2.PropTypes.array,
	  resultIndex: _react2.PropTypes.number,
	  text: _react2.PropTypes.string,
	  originalText: _react2.PropTypes.string,
	  keywords: _react2.PropTypes.array,
	  destinations: _react2.PropTypes.array,
	  activities: _react2.PropTypes.array,
	  filterStyle: _react2.PropTypes.bool,
	  openMobileFilter: _react2.PropTypes.func,
	  messages: _react2.PropTypes.object
	  // userConfig: PropTypes.object
	}, _class2.defaultProps = {
	  filterStyle: false
	}, _temp2)) || _class) || _class));
	
	exports.default = SearchBox;
	module.exports = exports['default'];

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hilightKeyword = hilightKeyword;
	function hilightKeyword(keyword, text) {
	  var indexes = [];
	  text.split('').map(function (textChar) {
	    var found = false;
	    keyword.split('').map(function (keywordChar, index) {
	      if (found) {
	        return true;
	      }
	      if (textChar.toLowerCase() === keywordChar.toLowerCase() && indexes.indexOf(index) < 0) {
	        indexes.push(index);
	        found = true;
	      }
	    });
	  });
	  return indexes;
	}

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_3G7fXxfzzL-5i3O1q0rkSu _1sIUL8Csti_qoesv1eSx1i","inner":"_29nvn_Zx-7PsvoJqxMjVqh _41i8Pp6PmcXzDbgWssrnp","notfound-image":"_3pOLsRJKkoPuGtDSVMl5jH","link":"_1d_AOzKmvDE5ciuj152vn7","search-container":"_3E-YRjVv8US4BCgBKm_kAk","banner-shadow":"_1sslhcgs4TuCjGssEhdCym","inspirations-container":"_1wWSAyJIsS8RpKXqtVo5Is","inspiration-card":"awSy4ydPJGIwsKc83X8wV","card-image":"_2TlNx6FiJtE_2qNmj98eQz","card-detail":"_3_ZajiPGv9Pv-UzN7Vy2TA _13UyNN6lRQaIE4nGDzE2-d","inspiration-name":"_2j3PwpBQUl2-ZpiSB6HPVb","inspiration-description":"_1EFdJDPZWHwLkNpSz9DhpA","see-more-container":"_2Cg4Z1Bq__lFJOHIAtvZCn _13UyNN6lRQaIE4nGDzE2-d","card-shadow":"lagH2tNNslUBw7Katd-Ue _1sslhcgs4TuCjGssEhdCym _3jblqlydyeJqpKzpSv89pq"};

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8edaa69e4c7a7655336e7866f5848fc0.png";

/***/ }),

/***/ 1683:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(39);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _NotFound = __webpack_require__(1273);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxAsyncConnect = __webpack_require__(34);
	
	var _inspirations = __webpack_require__(265);
	
	var InspirationsAction = _interopRequireWildcard(_inspirations);
	
	var _suggestion = __webpack_require__(220);
	
	var _SearchBox = __webpack_require__(463);
	
	var _SearchBox2 = _interopRequireDefault(_SearchBox);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  NotFound: {
	    displayName: 'NotFound'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/NotFound/NotFound.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var NotFound = _wrapComponent('NotFound')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch;
	
	    var promises = [];
	    promises.push(dispatch((0, _inspirations.loadRandomInspirations)()));
	    promises.push(dispatch((0, _suggestion.loadKeywords)()));
	    return _promise2.default.all(promises);
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    randomInspirations: state.inspirations.randomInspirations,
	    locale: state.language.locale
	  };
	}, InspirationsAction), _dec3 = (0, _reactCssModules2.default)(_NotFound2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(NotFound, _Component);
	
	  function NotFound() {
	    (0, _classCallCheck3.default)(this, NotFound);
	    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NotFound, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          randomInspirations = _props.randomInspirations,
	          locale = _props.locale;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(_reactHelmet2.default, { title: '404 Not Found | ' }),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          _react3.default.createElement('img', { src: __webpack_require__(1433), styleName: 'notfound-image', alt: 'Not found image' }),
	          _react3.default.createElement(
	            'h1',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.header' })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'search-container' },
	            _react3.default.createElement(_SearchBox2.default, { filterStyle: true })
	          ),
	          _react3.default.createElement(
	            'p',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_1',
	              values: {
	                location: locale === 'th' ? _react3.default.createElement(
	                  _Link2.default,
	                  { to: '/inspirations', className: _NotFound2.default.link },
	                  '\u0E42\u0E15\u0E40\u0E01\u0E35\u0E22\u0E27'
	                ) : _react3.default.createElement(
	                  _Link2.default,
	                  { to: '/to/Bangkok', className: _NotFound2.default.link },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_1.bangkok' })
	                )
	              }
	            })
	          ),
	          _react3.default.createElement(
	            'p',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_2' })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'inspirations-container' },
	            randomInspirations.map(function (insp) {
	              if (insp.is_public) {
	                return _react3.default.createElement(
	                  _Link2.default,
	                  { key: insp._id, styleName: 'inspiration-card', to: '/inspiration/' + insp.slug },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'card-image', style: (0, _media.path)(insp.thumbnail_image, 'coverTripCard', true) },
	                    _react3.default.createElement(
	                      'div',
	                      { styleName: 'card-shadow' },
	                      _react3.default.createElement(
	                        'h2',
	                        null,
	                        insp.name
	                      )
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'card-detail' },
	                    _react3.default.createElement(
	                      'h3',
	                      { styleName: 'inspiration-name' },
	                      insp.name
	                    ),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'inspiration-description' },
	                      insp.description
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'see-more-container' },
	                    _react3.default.createElement(
	                      'span',
	                      null,
	                      'See more'
	                    )
	                  )
	                );
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return NotFound;
	}(_react2.Component), _class2.propTypes = {
	  randomInspirations: _react2.PropTypes.array,
	  locale: _react2.PropTypes.string
	}, _temp)) || _class) || _class) || _class));
	
	exports.default = NotFound;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// not-found-c1ef0d7736bfbf8ee887.js